window.Breakpoints = {
  tiny: 350,
  small: 650,
  medium: 850,
  large: 1224,
  xlarge: 1450
};